import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from "styled-components";
import { Icon } from "../../icon";
// components
import { StyledContent } from "./FlyoutItem.styles";
function includesCaseSensitive(phrase, term) {
    return phrase.toLowerCase().includes(term.toLowerCase());
}
function getPhraseParts(phrase, term = "") {
    if (typeof phrase !== "string") {
        return [undefined, undefined, undefined];
    }
    if (!includesCaseSensitive(phrase, term)) {
        return ["", "", phrase];
    }
    const [start, ...rest] = phrase === null || phrase === void 0 ? void 0 : phrase.toLowerCase().split(term.toLowerCase());
    const end = rest.join(term);
    // return parts of the original string to ensure that case is preserved
    return [
        phrase.slice(0, start.length),
        phrase.slice(start.length, start.length + term.length),
        end ? phrase.slice(-end.length) : "",
    ];
}
export function FlyoutItem({ content, inputValue, symbol, isActive, }) {
    const theme = useTheme();
    const iconColor = isActive ? theme.colors.primaryLight : "";
    if (!inputValue) {
        const text = typeof content === "string" ? content : content.text;
        return (_jsxs(_Fragment, { children: [symbol && _jsx(Icon, { symbol: symbol, color: iconColor, withHitSpace: true }), _jsx(StyledContent, Object.assign({ "$color": iconColor }, { children: text }))] }));
    }
    const [start, input, rest] = getPhraseParts(content, inputValue);
    return (_jsxs(_Fragment, { children: [symbol && _jsx(Icon, { symbol: symbol, color: iconColor, withHitSpace: true }), _jsxs(StyledContent, Object.assign({ isAutocomplete: true }, { children: [rest !== undefined && !!start.trimLeft() && (_jsx("span", Object.assign({ className: "start" }, { children: start.trimLeft() }))), _jsxs("span", { children: [rest !== undefined && content.includes(input) && (_jsx("strong", { children: input })), _jsx("span", { children: rest })] })] }))] }));
}
